"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useGetKeyByActivity;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useGetKeyByActivity() {
  return (0, _useContext.default)().getKeyByActivity;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VHZXRLZXlCeUFjdGl2aXR5IiwidXNlQWN0aXZpdHlLZXllckNvbnRleHQiLCJnZXRLZXlCeUFjdGl2aXR5Il0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcHJvdmlkZXJzL0FjdGl2aXR5S2V5ZXIvdXNlR2V0S2V5QnlBY3Rpdml0eS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFdlYkNoYXRBY3Rpdml0eSB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWNvcmUnO1xuXG5pbXBvcnQgdXNlQWN0aXZpdHlLZXllckNvbnRleHQgZnJvbSAnLi9wcml2YXRlL3VzZUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VHZXRLZXlCeUFjdGl2aXR5KCk6IChhY3Rpdml0eT86IFdlYkNoYXRBY3Rpdml0eSkgPT4gc3RyaW5nIHwgdW5kZWZpbmVkIHtcbiAgcmV0dXJuIHVzZUFjdGl2aXR5S2V5ZXJDb250ZXh0KCkuZ2V0S2V5QnlBY3Rpdml0eTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVBOzs7O0FBRWUsU0FBU0EsbUJBQVQsR0FBbUY7RUFDaEcsT0FBTyxJQUFBQyxtQkFBQSxJQUEwQkMsZ0JBQWpDO0FBQ0QifQ==